import React from 'react';
import classes from './techstars-logo.scss';
export default function TechstarsLogo() {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.plus
  }, "+"), /*#__PURE__*/React.createElement("div", {
    className: classes.image
  }));
}